import Clarity from '@microsoft/clarity';

import { CLARITY_PROJECT_ID } from './config-global';

export default function initClarity() {
  if (!CLARITY_PROJECT_ID) return;

  Clarity.init(CLARITY_PROJECT_ID);
}
